// Bootstrap JS
var bootstrap = require('bootstrap');


document.addEventListener('DOMContentLoaded', function() {
    // Initialize Masonry with proper image loading handling
    const grid = document.querySelector('.gallery-grid');
    if (grid) {
        // First load imagesLoaded
        const imagesLoadedScript = document.createElement('script');
        imagesLoadedScript.src = 'https://unpkg.com/imagesloaded@4/imagesloaded.pkgd.min.js';
        imagesLoadedScript.onload = function() {
            // Initialize Masonry after images load
            imagesLoaded(grid, function() {
                const msnry = new Masonry(grid, {
                    itemSelector: '.gallery-item',
                    percentPosition: true,
                    transitionDuration: 0 // Remove animation to prevent flash
                });
                
                // Re-layout on window resize
                window.addEventListener('resize', function() {
                    msnry.layout();
                });
            });
        };
        document.head.appendChild(imagesLoadedScript);
    }

    // Lightbox functionality
    const lightboxModal = new bootstrap.Modal('#galleryModal');
    const modalImage = document.getElementById('modalImage');
    const modalCaption = document.getElementById('modalCaption');
    
    // Handle gallery link clicks
    document.querySelectorAll('.gallery-link').forEach(link => {
        link.addEventListener('click', function(e) {
            e.preventDefault();
            
            // Show loading state
            modalImage.classList.add('loading');
            
            // Set image and caption
            modalImage.src = '';
            modalImage.alt = this.querySelector('img').alt;
            modalCaption.textContent = this.dataset.caption || '';
            
            // Load image after a small delay
            setTimeout(() => {
                modalImage.src = this.href;
                modalImage.onload = () => {
                    modalImage.classList.remove('loading');
                    lightboxModal.show();
                };
            }, 50);
        });
    });
    
    // Clean up when modal closes
    document.getElementById('galleryModal').addEventListener('hidden.bs.modal', function() {
        modalImage.src = '';
        modalImage.alt = '';
        modalCaption.textContent = '';
    });
});